(() => {
  const main = document.getElementById('MainContent');
  if (!main) return;
  const groups = [
    ['.sbc-hero-carousel', '.sbc-hero-carousel__track', '.sbc-hero-carousel__image'],
    ['sbc-noel-nouveautes', '.sbc-noel__track', '.sbc-noel__picture'],
    ['sbc-scoops-carousel', '.sbc-home-scoops__grid', '.sbc-scoop-card__media'],
    ['.sbc-home-category__carousel', '.sbc-home-category__track', '.sbc-search-item__media'],
    ['.sbc-reviews__carousel', '.sbc-reviews__track', '.sbc-review-card__photo'],
    ['.home-avis__etsy-carousel', '.home-avis__etsy-track', '.home-avis__etsy-photo'],
    ['.sbc-product-extras > .shell', '.sbc-product-extras__track', '.sbc-search-item__media']
  ];
  const selector = groups.map(([root]) => root).join(',');
  const active = new Map();

  const connect = (root) => {
    if (active.has(root)) return;
    const [, trackSelector, mediaSelector] = groups.find(([match]) => root.matches(match));
    const track = root.querySelector(trackSelector);
    if (!track) return;
    const controller = new AbortController();
    let frame = 0;
    const measure = () => {
      frame = 0;
      const bounds = track.getBoundingClientRect();
      if (!bounds.width || !bounds.height) return;
      const photo = root.matches('.sbc-hero-carousel')
        ? track
        : track.querySelector(mediaSelector) || track.firstElementChild;
      if (!photo) return;
      const image = photo.getBoundingClientRect();
      const top = root.getBoundingClientRect().top;
      const value = `${Math.round(image.top - top + image.height / 2)}px`;
      if (root.style.getPropertyValue('--sbc-arrow-y') !== value) {
        root.style.setProperty('--sbc-arrow-y', value);
      }
    };
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(measure);
    };
    root.addEventListener('load', schedule, { capture: true, signal: controller.signal });
    window.addEventListener('resize', schedule, { passive: true, signal: controller.signal });
    const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
    observer?.observe(root);
    observer?.observe(track);
    const reference = track.querySelector(mediaSelector);
    if (reference) observer?.observe(reference);
    active.set(root, () => {
      controller.abort();
      observer?.disconnect();
      cancelAnimationFrame(frame);
    });
    schedule();
  };

  main.querySelectorAll(selector).forEach(connect);
  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches(selector)) connect(node);
        node.querySelectorAll(selector).forEach(connect);
      }
    }
    for (const [root, disconnect] of active) {
      if (!root.isConnected) {
        disconnect();
        active.delete(root);
      }
    }
  }).observe(main, { childList: true, subtree: true });
})();



